import React, { Component } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { OMCList } from '@C/Utils';
import { authHeader } from '@H';
import { confirmAlert } from 'react-confirm-alert';
import FuelList from './FuelList';

class Fuels extends Component {
  constructor(props) {
    super(props);
    this.state = {
      omc_id: '',
      product: '',
      time_stamp: dayjs().format('YYYY-MM-DD'),
      updated: false,
      editMode: false,
      isSubmitting: false,
    };
    this.editRef = React.createRef();
  }

  handleDate = (e) => {
    this.setState({ time_stamp: e.target.value });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleOMCChange = (e) => {
    this.setState({ omc_id: e });
  };

  handleEditMode = () => {};

  confirmSubmit = (e) => {
    const { product } = this.state;
    confirmAlert({
      title: 'Are you sure you want to',
      message: this.state.editMode ? `update ${product}` : 'add a new fuel',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.submitForm(e),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ isSubmitting: true });
    const formData = this.state;
    const headers = authHeader(1);

    if (this.state.editMode) {
      axios
        .put(`${process.env.API_URL}/bunk/omc/product/`, formData, { headers })
        .then(() => {
          toast.success('Fuel updated successfully', {
            position: 'bottom-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          window.scrollTo({
            behavior: 'smooth',
            top: this.editRef.current.offsetTop - 150,
          });
          this.setState({
            omc_id: '',
            product: '',
            time_stamp: dayjs().format('YYYY-MM-DD'),
            editMode: false,
            updated: !this.state.updated,
            isSubmitting: false,
          });
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
          this.setState({ isSubmitting: false });
        });
    } else {
      axios
        .post(`${process.env.API_URL}/bunk/omc/product/`, formData, {
          headers,
        })
        .then(() => {
          toast.success('Fuel added successfully', {
            position: 'bottom-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          window.scrollTo({
            behavior: 'smooth',
            top: this.editRef.current.offsetTop - 150,
          });
          this.setState({
            omc_id: '',
            product: '',
            time_stamp: dayjs().format('YYYY-MM-DD'),
            editMode: false,
            updated: !this.state.updated,
            isSubmitting: false,
          });
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
          this.setState({ isSubmitting: false });
        });
    }
  };

  render() {
    const { editMode } = this.state;
    return (
      <>
        <section className="widget full-width form-table" ref={this.editRef}>
          <header>
            <h3> Fuels</h3>
          </header>
          <main>
            <div className="form-header">
              <div className="input-wrapper">
                <input
                  className="cstm-date-input"
                  type="date"
                  value={this.state.time_stamp}
                  name="time_stamp"
                  onChange={this.handleDate}
                />
              </div>
            </div>
            <div className="form-content">
              <table>
                <thead>
                  <tr>
                    <th>Fuel Name</th>
                    <th>OMC</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className={`${editMode ? 'highlight-bg' : ''}`}>
                    <td>
                      <div className="input-wrapper">
                        <input
                          name="product"
                          type="text"
                          onChange={this.handleChange}
                          placeholder="Fuel name"
                          value={this.state.product}
                        />
                      </div>
                    </td>
                    <td>
                      <OMCList
                        handleOMCChange={this.handleOMCChange}
                        value={this.state.omc_id}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="form-actions">
              <button
                className="submit"
                type="submit"
                disabled={this.state.isSubmitting}
                onClick={this.confirmSubmit}
              >
                Submit
              </button>
              {editMode && (
                <button className="red-btn" onClick={this.cancelEdit}>
                  Cancel
                </button>
              )}
            </div>
          </main>
        </section>
        <FuelList key={this.state.updated} onEdit={this.handleEditMode} />
      </>
    );
  }
}

export { Fuels };
